// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ReferencesRouteImport } from './routes/references'
import { Route as OutilsRouteImport } from './routes/outils'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConfidentialiteRouteImport } from './routes/confidentialite'
import { Route as CgvRouteImport } from './routes/cgv'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AProposRouteImport } from './routes/a-propos'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NlIndexRouteImport } from './routes/nl.index'
import { Route as EnIndexRouteImport } from './routes/en.index'
import { Route as NlWettelijkeVermeldingenRouteImport } from './routes/nl.wettelijke-vermeldingen'
import { Route as NlToolsRouteImport } from './routes/nl.tools'
import { Route as NlReferentiesRouteImport } from './routes/nl.referenties'
import { Route as NlPrivacyRouteImport } from './routes/nl.privacy'
import { Route as NlOverOnsRouteImport } from './routes/nl.over-ons'
import { Route as NlFaqRouteImport } from './routes/nl.faq'
import { Route as NlDienstenRouteImport } from './routes/nl.diensten'
import { Route as NlCookiesRouteImport } from './routes/nl.cookies'
import { Route as NlContactRouteImport } from './routes/nl.contact'
import { Route as NlAlgemeneVoorwaardenRouteImport } from './routes/nl.algemene-voorwaarden'
import { Route as EnToolsRouteImport } from './routes/en.tools'
import { Route as EnTermsRouteImport } from './routes/en.terms'
import { Route as EnServicesRouteImport } from './routes/en.services'
import { Route as EnReferencesRouteImport } from './routes/en.references'
import { Route as EnPrivacyRouteImport } from './routes/en.privacy'
import { Route as EnLegalRouteImport } from './routes/en.legal'
import { Route as EnFaqRouteImport } from './routes/en.faq'
import { Route as EnCookiesRouteImport } from './routes/en.cookies'
import { Route as EnContactRouteImport } from './routes/en.contact'
import { Route as EnAboutRouteImport } from './routes/en.about'
import { Route as AdminLoginRouteImport } from './routes/admin_.login'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminToolsRouteImport } from './routes/admin.tools'
import { Route as AdminStatsRouteImport } from './routes/admin.stats'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminServicesRouteImport } from './routes/admin.services'
import { Route as AdminReferencesRouteImport } from './routes/admin.references'
import { Route as AdminPagesRouteImport } from './routes/admin.pages'
import { Route as AdminMessagesRouteImport } from './routes/admin.messages'
import { Route as AdminMenusRouteImport } from './routes/admin.menus'
import { Route as AdminMediaRouteImport } from './routes/admin.media'
import { Route as AdminLegalRouteImport } from './routes/admin.legal'
import { Route as AdminHistoryRouteImport } from './routes/admin.history'
import { Route as AdminFaqRouteImport } from './routes/admin.faq'
import { Route as AdminSettingsSeoRouteImport } from './routes/admin.settings.seo'

const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ReferencesRoute = ReferencesRouteImport.update({
            id: '/references',path: '/references',getParentRoute: () => rootRouteImport
          })
const OutilsRoute = OutilsRouteImport.update({
            id: '/outils',path: '/outils',getParentRoute: () => rootRouteImport
          })
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
            id: '/mentions-legales',path: '/mentions-legales',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ConfidentialiteRoute = ConfidentialiteRouteImport.update({
            id: '/confidentialite',path: '/confidentialite',getParentRoute: () => rootRouteImport
          })
const CgvRoute = CgvRouteImport.update({
            id: '/cgv',path: '/cgv',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AProposRoute = AProposRouteImport.update({
            id: '/a-propos',path: '/a-propos',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const NlIndexRoute = NlIndexRouteImport.update({
            id: '/nl/',path: '/nl/',getParentRoute: () => rootRouteImport
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/en/',path: '/en/',getParentRoute: () => rootRouteImport
          })
const NlWettelijkeVermeldingenRoute = NlWettelijkeVermeldingenRouteImport.update({
            id: '/nl/wettelijke-vermeldingen',path: '/nl/wettelijke-vermeldingen',getParentRoute: () => rootRouteImport
          })
const NlToolsRoute = NlToolsRouteImport.update({
            id: '/nl/tools',path: '/nl/tools',getParentRoute: () => rootRouteImport
          })
const NlReferentiesRoute = NlReferentiesRouteImport.update({
            id: '/nl/referenties',path: '/nl/referenties',getParentRoute: () => rootRouteImport
          })
const NlPrivacyRoute = NlPrivacyRouteImport.update({
            id: '/nl/privacy',path: '/nl/privacy',getParentRoute: () => rootRouteImport
          })
const NlOverOnsRoute = NlOverOnsRouteImport.update({
            id: '/nl/over-ons',path: '/nl/over-ons',getParentRoute: () => rootRouteImport
          })
const NlFaqRoute = NlFaqRouteImport.update({
            id: '/nl/faq',path: '/nl/faq',getParentRoute: () => rootRouteImport
          })
const NlDienstenRoute = NlDienstenRouteImport.update({
            id: '/nl/diensten',path: '/nl/diensten',getParentRoute: () => rootRouteImport
          })
const NlCookiesRoute = NlCookiesRouteImport.update({
            id: '/nl/cookies',path: '/nl/cookies',getParentRoute: () => rootRouteImport
          })
const NlContactRoute = NlContactRouteImport.update({
            id: '/nl/contact',path: '/nl/contact',getParentRoute: () => rootRouteImport
          })
const NlAlgemeneVoorwaardenRoute = NlAlgemeneVoorwaardenRouteImport.update({
            id: '/nl/algemene-voorwaarden',path: '/nl/algemene-voorwaarden',getParentRoute: () => rootRouteImport
          })
const EnToolsRoute = EnToolsRouteImport.update({
            id: '/en/tools',path: '/en/tools',getParentRoute: () => rootRouteImport
          })
const EnTermsRoute = EnTermsRouteImport.update({
            id: '/en/terms',path: '/en/terms',getParentRoute: () => rootRouteImport
          })
const EnServicesRoute = EnServicesRouteImport.update({
            id: '/en/services',path: '/en/services',getParentRoute: () => rootRouteImport
          })
const EnReferencesRoute = EnReferencesRouteImport.update({
            id: '/en/references',path: '/en/references',getParentRoute: () => rootRouteImport
          })
const EnPrivacyRoute = EnPrivacyRouteImport.update({
            id: '/en/privacy',path: '/en/privacy',getParentRoute: () => rootRouteImport
          })
const EnLegalRoute = EnLegalRouteImport.update({
            id: '/en/legal',path: '/en/legal',getParentRoute: () => rootRouteImport
          })
const EnFaqRoute = EnFaqRouteImport.update({
            id: '/en/faq',path: '/en/faq',getParentRoute: () => rootRouteImport
          })
const EnCookiesRoute = EnCookiesRouteImport.update({
            id: '/en/cookies',path: '/en/cookies',getParentRoute: () => rootRouteImport
          })
const EnContactRoute = EnContactRouteImport.update({
            id: '/en/contact',path: '/en/contact',getParentRoute: () => rootRouteImport
          })
const EnAboutRoute = EnAboutRouteImport.update({
            id: '/en/about',path: '/en/about',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin_/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const AdminToolsRoute = AdminToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => AdminRoute
          })
const AdminStatsRoute = AdminStatsRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminServicesRoute = AdminServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => AdminRoute
          })
const AdminReferencesRoute = AdminReferencesRouteImport.update({
            id: '/references',path: '/references',getParentRoute: () => AdminRoute
          })
const AdminPagesRoute = AdminPagesRouteImport.update({
            id: '/pages',path: '/pages',getParentRoute: () => AdminRoute
          })
const AdminMessagesRoute = AdminMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AdminRoute
          })
const AdminMenusRoute = AdminMenusRouteImport.update({
            id: '/menus',path: '/menus',getParentRoute: () => AdminRoute
          })
const AdminMediaRoute = AdminMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => AdminRoute
          })
const AdminLegalRoute = AdminLegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => AdminRoute
          })
const AdminHistoryRoute = AdminHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => AdminRoute
          })
const AdminFaqRoute = AdminFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => AdminRoute
          })
const AdminSettingsSeoRoute = AdminSettingsSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AdminSettingsRoute
          })





const AdminSettingsRouteChildren = {
  AdminSettingsSeoRoute: AdminSettingsSeoRoute
}

const AdminSettingsRouteWithChildren = AdminSettingsRoute._addFileChildren(AdminSettingsRouteChildren)



const AdminRouteChildren = {
  AdminFaqRoute: AdminFaqRoute,AdminHistoryRoute: AdminHistoryRoute,AdminLegalRoute: AdminLegalRoute,AdminMediaRoute: AdminMediaRoute,AdminMenusRoute: AdminMenusRoute,AdminMessagesRoute: AdminMessagesRoute,AdminPagesRoute: AdminPagesRoute,AdminReferencesRoute: AdminReferencesRoute,AdminServicesRoute: AdminServicesRoute,AdminSettingsRoute: AdminSettingsRouteWithChildren,AdminStatsRoute: AdminStatsRoute,AdminToolsRoute: AdminToolsRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AProposRoute: AProposRoute,AdminRoute: AdminRouteWithChildren,CgvRoute: CgvRoute,ConfidentialiteRoute: ConfidentialiteRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,FaqRoute: FaqRoute,MentionsLegalesRoute: MentionsLegalesRoute,OutilsRoute: OutilsRoute,ReferencesRoute: ReferencesRoute,ServicesRoute: ServicesRoute,AdminLoginRoute: AdminLoginRoute,EnAboutRoute: EnAboutRoute,EnContactRoute: EnContactRoute,EnCookiesRoute: EnCookiesRoute,EnFaqRoute: EnFaqRoute,EnLegalRoute: EnLegalRoute,EnPrivacyRoute: EnPrivacyRoute,EnReferencesRoute: EnReferencesRoute,EnServicesRoute: EnServicesRoute,EnTermsRoute: EnTermsRoute,EnToolsRoute: EnToolsRoute,NlAlgemeneVoorwaardenRoute: NlAlgemeneVoorwaardenRoute,NlContactRoute: NlContactRoute,NlCookiesRoute: NlCookiesRoute,NlDienstenRoute: NlDienstenRoute,NlFaqRoute: NlFaqRoute,NlOverOnsRoute: NlOverOnsRoute,NlPrivacyRoute: NlPrivacyRoute,NlReferentiesRoute: NlReferentiesRoute,NlToolsRoute: NlToolsRoute,NlWettelijkeVermeldingenRoute: NlWettelijkeVermeldingenRoute,EnIndexRoute: EnIndexRoute,NlIndexRoute: NlIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)